module.exports = __webpack_public_path__ + "static/media/repeatable-table-off-preview.331adae0.png";